import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import useSWR from 'swr'
import Select from 'react-select'
import classNames from 'classnames'
import categoriesWithoutCourses from 'api/courses/categoriesWithoutCourses'
import { useIsMobile } from 'hooks/useIsMobile'
import { paths } from 'routes/paths'
import getPopularsLibrary from 'api/courses/populars_library'
import styles from './CategoriesSelect.module.scss'

interface Props {
  onSelect: (selected: any) => void
}

export const CategoriesSelect = ({ onSelect }: Props) => {
  const { t } = useTranslation()
  const isMobile = useIsMobile()

  const { data: populars, isLoading: isLoadingPopulars } = useSWR(
    {
      key: 'populars_library',
      search: '',
    },
    async (arg) =>
      getPopularsLibrary({
        page: 1,
        perPage: 8,
        search: arg.search,
      })
  )

  const { data, isLoading } = useSWR('categories-library', async () =>
    categoriesWithoutCourses()
  )

  const options = useMemo(() => {
    return [
      {
        value: 'all',
        label: t('availableCourses.dropdown.placeholder'),
      },
      ...(populars?.courses.length
        ? [
            {
              value: 'populars',
              label: t('availableCourses.dropdown.populars'),
              path: paths.library.populars,
            },
          ]
        : []),
      ...(data?.premieres.count
        ? [
            {
              value: 'premieres',
              label: t('availableCourses.dropdown.premieres'),
              path: paths.library.premieres,
            },
          ]
        : []),
      ...(data?.folders || []).flatMap(({ id, name }) => ({
        value: id.toString(),
        label: name,
        path: paths.library.folder.details(id, name),
      })),
    ]
  }, [t, data, populars])

  const [selected, setSelected] = useState<any>(options[0])

  return (
    <Select
      onChange={(selected) => {
        setSelected(selected)
        onSelect(selected)
      }}
      options={options}
      classNamePrefix="react-select"
      className={classNames(
        styles.selectFilter,
        isMobile ? styles.selectFilterMobile : ''
      )}
      value={selected}
      isLoading={isLoading || isLoadingPopulars}
    />
  )
}
